import { Component } from "@angular/core";
import { AdminConsoleService } from "@services/admin-console/admin-console.service";
import { map, Observable } from "rxjs";

@Component({
    selector: "app-admin-console",
    templateUrl: "./admin-console.component.html",
    styleUrls: ["./admin-console.component.css"]
})
export class AdminConsoleComponent {

    protected isFullAdmin$: Observable<boolean>;

    constructor(
        private adminConsoleService: AdminConsoleService
    ) {
        this.isFullAdmin$ = this.adminConsoleService.getAdminStatus()
            .pipe(
                map((status) => !!status?.isOwner)
            );
    }
};
